import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom';
import { useGamifiedMessage, useIsDisqualified } from '../../hooks';

import { PageTransitionWrapper } from '../../components';
import FailedTtLayout from './components/failedTtLayout/FailedTtLayout';
import { DisqualifiedLayout } from './components/disqualifiedLayout/DisqualifiedLayout';
import { SuccessLayout } from './components/successLayout/SuccessLayout';

import { logEvent } from 'src/services';

const ApplicationSuccess: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const { updateGamifiedMessage } = useGamifiedMessage();

  const { isDisqualified, isFailedTestTask } = useIsDisqualified();

  useEffect(() => {
    if (navigationType.toString() === 'POP') {
      navigate(1);
      return;
    }
  }, [location]);

  useEffect(() => {
    logEvent('launchpod-application-success-page-loaded');
    updateGamifiedMessage(null);
  }, []);

  const Layout = useMemo(() => {
    if (isFailedTestTask) return FailedTtLayout;

    if (isDisqualified) return DisqualifiedLayout;

    return SuccessLayout;
  }, [isFailedTestTask, isDisqualified]);

  if (!Layout) return null;

  return (
    <PageTransitionWrapper data-testid="application-success-layout">
      <Layout />
    </PageTransitionWrapper>
  );
};

export default ApplicationSuccess;
